// extracted by mini-css-extract-plugin
export var titlelink = "title-link-module--titlelink--73343";
export var white = "title-link-module--white--46dc2";